import React, { Component } from "react";
import axios from 'axios';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";

import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isHMM = ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/' || ROOT_URL === 'https://hmm-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';

const addShippingAddress = (data, receivingCustomer, success, failure) => {
  axios({
    method: 'PUT',
    data,
    url: `${ROOT_URL}v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
  .then(res => {
    success();
  }, err => {
    failure();
    const data = err.data;
    alert(JSON.stringify(data));
  })
}

const dataValid = (data) => {
  if (isHMM) {
    if (!data.AddressName || !data.Telephone) {
      return;
    }
  } else if (isMAG) {
    if (!data.AddressName || !data.Street || !data.City || !data.State || !data.Zip || !data.DrayageCode) {
      return;
    }
  } else {
    if (!data.AddressName || !data.Telephone || !data.Street || !data.Cellphone || !data.City || !data.Email || !data.State || !data.Zip) {
      return;
    }
  }
  return true;
}

const fetchCustomerDetails = (receivingCustomer, success) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}/v1/customer/${receivingCustomer}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
  .then(res => {
    success(res);
  }, err => {

  })
}

class ShippingAddressEditmodal extends Component {
  constructor() {
    super();
    this.state = {
      buttonDisabled: false,
    };
  }

  componentDidMount() {
    fetchCustomerDetails(this.props.receivingCustomer, this.handleFetchCustomerDetailsSuccess)
  }

  handleInputFieldChange = ({ name, value }) =>
    this.setState({ [name]: value });

    
  handleFetchCustomerDetailsSuccess = ({ data }) => {
    this.setState({
      IsDefault: "true",
      AddressName: "",
      Telephone: "",
      Street: "",
      City: "",
      State: "",
      Zip: "",
      Email: "",
      Cellphone: "",
      DrayageCode: "",
      customerDetails: data,
    })
  }

  handleSubmit = () => {

    if (!dataValid(this.state)) {
      alert('fill in required fields')
      return;
    }

    this.setState({
      buttonDisabled: true,
    })
    const customerDetails = {
      ...this.state.customerDetails
    }

    const data = {
      ...this.state,
    };
  
    delete data.customerDetails

    // customerDetails.Shipping = [data];
    customerDetails.Shipping.push(data);

    addShippingAddress(customerDetails, this.props.receivingCustomer, () => {
      this.props.reFetchSalesCustomers();
      this.setState({
        buttonDisabled: false,
      })
    }, () => {      this.setState({
      buttonDisabled: false,
    });
    customerDetails.Shipping.splice(-1,1);
  })
  };

  render() {
    const { AddressName, Telephone, Street, City, State, Zip, Cellphone, Email, DrayageCode } = this.state;
    return (
      <div>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="name" /><span style={{color: 'red'}}>{isMAG ? "*" : ""}</span>:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="cell_phone" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="AddressName"
              value={AddressName}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Telephone"
              value={Telephone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="alt_phone" />:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="email" />:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="Cellphone"
              value={Cellphone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Email"
              value={Email}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="street" /><span style={{color: 'red'}}>{isMAG ? "*" : ""}</span>:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="city" /><span style={{color: 'red'}}>{isMAG ? "*" : ""}</span>:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="Street"
              value={Street}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="City"
              value={City}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="state" /><span style={{color: 'red'}}>{isMAG ? "*" : ""}</span>:
            </label>
          </Col>
          <Col sm={6}>
            <label>
              <Translate value="zip" /><span style={{color: 'red'}}>{isMAG ? "*" : ""}</span>:
            </label>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="State"
              value={State}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          <Col sm={6}>
            <Input
              type="text"
              name="Zip"
              value={Zip}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
        </Row>
{
  isMAG &&
        <Row>
          <Col sm={6}>
            <label>
              <Translate value="drayage_code" /><span style={{color: 'red'}}>{isMAG ? "*" : ""}</span>:
            </label>
          </Col>
          {/* <Col sm={6}>
            <label>
              <Translate value="cell_phone" />:
            </label>
          </Col> */}
        </Row>
        }
        {isMAG &&
        <Row>
          <Col sm={6}>
            <Input
              type="text"
              name="DrayageCode"
              value={DrayageCode}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col>
          {/* <Col sm={6}>
            <Input
              type="text"
              name="Telephone"
              value={Telephone}
              onChange={(e) => this.handleInputFieldChange(e.target)}
            />
          </Col> */}
        </Row>
  }

        <Row className="centerStyle" style={{ marginTop: "0px" }}>
          <Button
            bsStyle="success"
            disabled={this.state.buttonDisabled}
            onClick={(e) => {
              this.handleSubmit();
            }}
            // disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
          >
            <Translate value="submit" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default ShippingAddressEditmodal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/shippingInfoEditModal.jsx